import MainSetups from '@/services/api/main-setups';

const transformResponseObject = (response) => {
  const { data } = response.data;
  const adminCodes = {
    adminCode: data.admin_code,
    displayNumber: data.display_number,
    id: data.id,
    doors: [
      {
        code: data.key_1_value,
        relay: data.key_1_relay,
      },
      {
        code: data.key_2_value,
        relay: data.key_2_relay,
      },
      {
        code: data.key_3_value,
        relay: data.key_3_relay,
      },
    ],
    keyEnable: data.key_enable,
    noAnswerAction: data.no_answer_action,
    sendKeyEnable: data.send_key_enable,
    serviceDoorCode: data.service_door_code,
    scanByCode: data.scan_by_code,
    doorCodeRotateAt: data.door_code_rotate_at,
    rotationLocked: !!data.door_code_rotation_locked,
    rotationComment: data.door_code_rotation_comment || '',
  };
  return adminCodes;
};

export default {
  state: {
    adminCodes: {},
  },
  getters: {
    adminCodes: state => state.adminCodes,
  },
  mutations: {
    setAdminCodes: (state, payload) => {
      state.adminCodes = payload;
    },
  },
  actions: {
    getAdminCodes (state, id) {
      return new Promise((resolve, reject) => {
        MainSetups.getAdminCodes(id)
          .then((response) => {
            const transformData = transformResponseObject(response);
            state.commit('setAdminCodes', transformData);
            resolve(transformData);
          })
          .catch(e => reject(e));
      });
    },
    importCodesFromDoorphone (state, { id }) {
      return new Promise((resolve, reject) => {
        MainSetups.importCodesFromDoorphone(id)
          .then(response => {
            const transformData = transformResponseObject(response);
            state.commit('setAdminCodes', transformData);
            resolve(transformData);
          })
          .catch(e => reject(e));
      });
    },
    updateAdminCodes (state, { id, codeData, lifetimeDays, rotationLocked, rotationComment }) {
      return new Promise((resolve, reject) => {
        const updatedData = {
          key_1_relay: codeData.relay[0].join(''),
          key_1_value: codeData.code[0],
          key_2_relay: codeData.relay[1].join(''),
          key_2_value: codeData.code[1],
          key_3_relay: codeData.relay[2].join(''),
          key_3_value: codeData.code[2],
        };
        if (rotationLocked !== undefined && rotationLocked !== null) {
          updatedData.rotation_locked = !!rotationLocked;
        }
        if (rotationLocked) {
          updatedData.rotation_comment = rotationComment || '';
        }
        if (lifetimeDays != null) {
          updatedData.lifetime_days = lifetimeDays;
        }
        MainSetups.saveAdminCodes(id, updatedData)
          .then((data) => resolve(data))
          .catch(e => reject(e));
      });
    },
    updateAdminCode (state, { doorphoneId, code }) {
      return MainSetups.updateAdminCode({ doorphoneId, code });
    },
    updateMassAdminCode (state, { adminCode, doorphones }) {
      return new Promise((resolve, reject) => {
        MainSetups.updateMassAdminCode({ adminCode, doorphones })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateMassConciergeNumber (state, { conciergeNumber, doorphones }) {
      return new Promise((resolve, reject) => {
        MainSetups.updateMassConciergeNumber({ conciergeNumber, doorphones })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAdminPassword (state, id) {
      return new Promise((resolve, reject) => {
        MainSetups.getAdminPassword(id)
          .then((response) => {
            resolve(response.data);
          })
          .catch(e => reject(e));
      });
    },
    updateAdminPassword (state, { id, adminPassword }) {
      return new Promise((resolve, reject) => {
        MainSetups.updateAdminPassword(id, adminPassword)
          .then((response) => {
            resolve(response.data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
